import { FormControlLabel, Switch as MuiSwitch, SwitchProps as MuiSwitchProps } from "@mui/material"
import React, { ReactNode } from "react"
import styled, { css } from "styled-components"
import { TextDisclaimer } from "../text"

export type SwitchProps = MuiSwitchProps & {
  label?: ReactNode
  description?: string
  className?: string
}

export const Switch = (props: SwitchProps) => {
  const { label, description, className, color = "primary", size = "medium", disabled, ...rest } = props

  return (
    <SwitchFormControlLabel
      className={className}
      control={<MuiSwitch color={color} disabled={disabled} size={size} {...rest} />}
      label={
        <SwitchLabel $size={size}>
          {label}
          <CustomTextDisclaimer $disabled={disabled}>{description}</CustomTextDisclaimer>
        </SwitchLabel>
      }
    />
  )
}

const SwitchFormControlLabel = styled(FormControlLabel)`
  align-items: flex-start;
`

const SwitchLabel = styled.div<{ $size: "small" | "medium" | undefined }>`
  display: flex;
  flex-flow: column;
  padding-top: ${(p) => (p.$size === "small" ? "0" : "6px")};
`

const CustomTextDisclaimer = styled(TextDisclaimer)<{ $disabled?: boolean }>`
  ${(p) =>
    p.$disabled === true &&
    css`
      color: inherit;
    `}
`
